import { render, staticRenderFns } from "./TestIndex.vue?vue&type=template&id=d82e386e&scoped=true&"
import script from "./TestIndex.vue?vue&type=script&lang=js&"
export * from "./TestIndex.vue?vue&type=script&lang=js&"
import style0 from "./TestIndex.vue?vue&type=style&index=0&id=d82e386e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82e386e",
  null
  
)

export default component.exports